import { createVanIconComponent } from "./van"

const Gift = createVanIconComponent("gift")
export default Gift
